import React from "react";
import { Link } from "react-router-dom";

const WaitlistDone = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center p-6 text-center gap-6">
            <h1 className="text-4xl font-bold">Thank you for signing up for early access!</h1>
            <p className="text-xl">We've sent you the download link. Check you mailbox{":)"}</p>
            <Link to="/" className="text-[#18a999] hover:underline">
                Return to homepage
            </Link>
        </div>
    );
};

export default WaitlistDone;
